export enum CartCounterVariantEnum {
    DEFAULT = 'default',
    COMPACT = 'compact',
}
